module.exports = __webpack_public_path__ + "static/media/iconRangeDate.e1dd372c.svg";